/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

import routes from '@routes/config';

export default [{
    path: routes.teleAssignedClaim.index,
    name: routes.teleAssignedClaim.index,
    component: () => import(/* webpackChunkName: "TeleAssignedClaim"*/  '@components/TeleAssignedClaim/Index')
}]
